import React from "react";

/**
 * Heading — editorial type primitive.
 * level: "display" | "h1" | "h2" | "h3" | "eyebrow"
 * font:  "serif" (Playfair) | "accent" (Cormorant) | "sans" (Manrope)
 */
const SIZES = {
  display:
    "font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]",
  h1: "font-serif text-3xl sm:text-4xl leading-[1.1] tracking-[-0.02em]",
  h2: "font-serif text-2xl sm:text-3xl leading-[1.15] tracking-[-0.015em]",
  h3: "font-serif text-xl sm:text-2xl leading-[1.2] tracking-[-0.01em]",
  eyebrow:
    "font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--foreground-muted))]",
};

const FONTS = {
  serif: "font-serif",
  accent: "font-accent italic",
  sans: "font-body",
};

export function Heading({
  as,
  level = "h2",
  font,
  className = "",
  children,
  ...rest
}) {
  const Tag = as || (level === "eyebrow" ? "p" : level === "display" ? "h1" : level);
  const sizeCls = SIZES[level] || SIZES.h2;
  const fontCls = font ? FONTS[font] : "";
  return (
    <Tag
      className={`text-[hsl(var(--foreground))] ${sizeCls} ${fontCls} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
